import React, { useState } from "react";
import { BiHomeAlt, BiUser } from "react-icons/bi";
import Arrow from "./Arrow";

const Footer = ({ isDarkMode }) => {
  const [isHovered, setIsHovered] = useState(false);

  // ✅ 滚动到页面顶部
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bottom-0 left-0 w-full py-8" id="footer">
      <div className="container mx-auto">
        <div className="mx-auto flex justify-center items-center">
          <button
            className="group cursor-pointer flex items-center justify-center"
            onClick={scrollToTop}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <div className="flex flex-row items-center gap-4">
              <Arrow isDarkMode={isDarkMode} isHovered={isHovered} />
              <div className="font-earth text-5xl md:text-8xl font-bold text-center">
                Back To Top
              </div>
            </div>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
